<template>
  <div>
    <Form :label-width="80" inline>
      <FormItem label="发货单号">
        <Input v-model="query.keyword" placeholder="请输入发货单号" style="width:200px"></Input>
      </FormItem>
      <Button type="success" @click="load">查询</Button>
      <Button style="margin-left:20px;" type="primary" icon="ios-search" @click="exportData(1)">导出数据</Button>
    </Form>
    <Table :loading="loading" :columns="columns" :data="data" ref="table"></Table>
  </div>
</template>

<script>
import { PmpRecord } from '@/services/resources'

export default {
  name: 'expressOutLogs2',
  data () {
    return {
      loading: false,
      query: {
        'info_key': 8,
        'info_type': 1,
        'keyword': ''
      },
      data: [],
      columns: [
        { title: '到达日期', key: 'receive_date' },
        { title: '产品型号', key: 'product_spec_name' },
        { title: 'S/N码', key: 'sn' },
        { title: '包装SN', key: 'sn2' },
        { title: '换新机SN', key: 'newsn' },
        { title: '维修方法', key: 'repair_method_name' },
        { title: '客户姓名', key: 'client_name' },
        { title: '客户地址', key: 'client_address' },
        // {title: '物品清单', key: 'receive_items_txt2'},
        {
          title: '物品清单',
          render (h, params) {
            return (
              <div>
                {params.row.receive_items_txt ? <div>{params.row.receive_items_txt.replace(',', ' ')}</div> : <div/>}
              </div>
            )
          }
        },
        { title: '收货公司', key: 'express_in_name' },
        { title: '收货单号', key: 'express_no_in' },
        { title: '发货公司', key: 'express_out_type_name' },
        { title: '发货单号', key: 'express_no_out' },
        { title: '发货时间', key: 'send_date' }
      ]
    }
  },
  methods: {
    load () {
      this.loading = true
      let params = Object.assign({}, { 'per-page': 200, 'page': 1 }, this.query)
      PmpRecord.query(params).then(res => {
        this.data = res.data
        this.loading = false
      })
    },
    exportData (type) {
      if (type === 1) {
        this.$Modal.confirm({
          title: '温馨提示',
          content: '导出数据之前请选择好条件，并执行查询操作！',
          onOk: () => {
            this.$refs.table.exportCsv({
              filename: '送货单-' + this.query.express_no_out
            })
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
